import { IconProps } from "./types";

export default function IcoOficialVehicle({ color = "#1D1D1D", size = "24" }: IconProps) {
	return (
		<svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M12 20C6.05714 17.6 4.19048 10.6667 4 7.5L12 4L20 7.5C20 15.5 14.6667 19.1667 12 20Z" stroke={color} strokeLinejoin="round" />
			<path
				d="M12 8L13.2931 10.2202L15.8042 10.7639L14.0923 12.6798L14.3511 15.2361L12 14.2L9.64886 15.2361L9.90768 12.6798L8.19577 10.7639L10.7069 10.2202L12 8Z"
				stroke={color}
				strokeLinejoin="round"
			/>
		</svg>
	);
}
